'use strict';

/* !
 * jQuery shop-search v1.0.0
 * Copyright 2016, Connecty Inc.
 * use: Google Maps API v3
 */
(function ($, SANGETSU, cssua) {
	var clickEvent = 'click';
	var jsonpathLargeArea = '/ajax/shop/large_area_list';
	var jsonpathSmallArea = void 0;
	var formContactUrl = 'https://biz.sangetsu.co.jp/regist/is?SMPFORM=qcti-lioglh-a91f6f71599181afcb5a0d5a9e8a4f8e';
	var $formAddress = $('#searchAddress');
	var $formZip = $('#searchZipcode');
	var canvas = document.getElementById('map-canvas');
	var map;
	var marker = [];
	var names = [];
	var address = [];
	var latlngs = [];
	var designatedCity = ['札幌市', '仙台市', 'さいたま市', '千葉市', '横浜市', '川崎市', '相模原市', '新潟市', '静岡市', '浜松市', '名古屋市', '京都市', '大阪市', '堺市', '神戸市', '岡山市', '広島市', '北九州市', '福岡市', '熊本市'];
	var currentInfoWindow;

	if (SANGETSU.va.pathname.indexOf('/shop_search/list/') !== -1) {
		// 検索結果一覧 /shop_search/list/
		if (!$('.vp_address').eq(0).text()) {
			$('#map-canvas').addClass('is-empty');
			$('.shop_search-result-empty').addClass('is-visible');
		} else {
			// 検索結果の先頭を選択状態に
			switchPickup(0);

			// 出力結果からマーカーを立てる住所を取得する
			$('.vp_address').each(function () {
				address.push($(this).text());
				names.push($(this).prev('.vp_shop_name').text());
			});

			address.reduce(function (promise, data, cnt) {
				return promise.then(function () {
					return geocodeAddress(data, cnt);
				});
			}, $.Deferred().resolve()).then(function () {
				initMap(latlngs);
				markerInfo(0);
			});
			// お問い合わせボタンクリック
			$(document).on(clickEvent, '.js-contact', function () {
				var contName = $(this).parents('.shop_search-result-item').find('.vp_shop_name').text();
				var contMail = $(this).parents('.shop_search-result-item').find('.vp_email_address').text();

				sendPostForm(contName, contMail);
			});
		}
	} else if (SANGETSU.va.pathname.indexOf('/middle_area_list/') !== -1) {
		// 中区分一覧 /shop_search/***/middle_area_list/~

		var smallAreaCode;
		if (SANGETSU.va.pathname.indexOf('curtain') !== -1) {
			$('.vc_middle_area_list').each(function () {
				smallAreaCode = $(this).find('.middle_area_code').text();
				$(this).find('a').attr('href', '/shop_search/curtain/small_area_list/' + smallAreaCode);
			});
		} else {
			$('.vc_middle_area_list').each(function () {
				smallAreaCode = $(this).find('.middle_area_code').text();
				var selectCat = searchReformCategoryQuery();
				$(this).find('a').attr('href', '/shop_search/reform/small_area_list/' + smallAreaCode + selectCat);
			});
		}
	} else if (SANGETSU.va.pathname.indexOf('/small_area_list/') !== -1) {
		// 小区分一覧 /shop_search/***/small_area_list/~

		var listCode, area;
		if (SANGETSU.va.pathname.indexOf('curtain') !== -1) {
			$('.vc_small_area_list').each(function () {
				listCode = $(this).find('.vc_small_area_code').text();
				area = $(this).find('.vc_address').text();

				$(this).find('a').attr('href', '/shop_search/list/curtain/' + listCode + '/' + area);
				getListCount($(this), 'curtain', listCode, area);
			});
		} else {
			$('.vc_small_area_list').each(function () {
				listCode = $(this).find('.vc_small_area_code').text();
				var selectCat = searchReformCategoryQuery();
				if (selectCat) {
					selectCat = searchReformCategoryQueryKana(selectCat);
					$(this).find('a').attr('href', '/shop_search/list/reform/area/' + listCode + '/' + selectCat);
				} else {
					$(this).find('a').attr('href', '/shop_search/list/reform/area/' + listCode);
				}
				getListCount($(this), 'reform', listCode, selectCat);
			});
		}
	} else {
		// 検索入力画面

		searchAddress();
		searchArea();

		// 郵便番号検索
		$('.js-submit-searchZipcode').on(clickEvent, function () {
			searchZipcode();
		});
		$('#inputSearchZipcode').keypress(function (e) {
			if (e.which === 13) {
				searchZipcode();
				return false;
			}
		});
	}

	function searchArea() {
		// 都道府県プルダウン
		$('.js-select-large_area').change(function () {
			var $smallSelect = $('.js-select-small_area');
			var largeAreaID = $(this).val();

			$smallSelect.find('option').remove();
			$smallSelect.append('<option value="">市町村を選択</option>');

			jsonpathSmallArea = '/ajax/shop/large_area/small_area_list/' + largeAreaID;

			$.getJSON(jsonpathSmallArea, function () {}).done(function (smallArea) {
				for (var i = 0; i < smallArea.small_area_list.length; i++) {
					var item = '<option value="' + smallArea.small_area_list[i]._key + '">' + smallArea.small_area_list[i].small_area_name + '</option>';
					$smallSelect.append(item);
				}
				$smallSelect.removeAttr('disabled');
			}).fail(function () {
				$smallSelect.attr('disabled', true);
			});
		});
	}
	function searchAddress() {
		// 地図検索のリンク作成
		$.getJSON(jsonpathLargeArea, function (largeArea) {
			for (var i = 0; i < largeArea.large_area_list.length; i++) {
				var item = '<option value="' + largeArea.large_area_list[i].large_area_code + '">' + largeArea.large_area_list[i].large_area_name + '</option>';
				$('.js-select-large_area').append(item);

				// 都道府県名でマッチ
				if (SANGETSU.va.pathname.indexOf('curtain') !== -1) {
					$('span:contains("' + largeArea.large_area_list[i].large_area_name + '")').parent('a').attr('href', '/shop_search/curtain/middle_area_list/' + largeArea.large_area_list[i].large_area_code);
				} else {
					$('span:contains("' + largeArea.large_area_list[i].large_area_name + '")').parent('a').attr('href', '/shop_search/reform/middle_area_list/' + largeArea.large_area_list[i].large_area_code);
				}
			}
		});

		// リフォームの場合：カテゴリチェック時に地図検索のリンクを全部修正する
		$('input[name=reform_category]').change(function () {
			var selectCat = $('input[name=reform_category]:checked').val();

			$.getJSON(jsonpathLargeArea, function (largeArea) {
				for (var i = 0; i < largeArea.large_area_list.length; i++) {
					var item = '<option value="' + largeArea.large_area_list[i].large_area_code + '">' + largeArea.large_area_list[i].large_area_name + '</option>';
					$('.js-select-large_area').append(item);

					$('span:contains("' + largeArea.large_area_list[i].large_area_name + '")').parent('a').attr('href', '/shop_search/reform/middle_area_list/' + largeArea.large_area_list[i].large_area_code + '?reform_category=' + selectCat);
				}
			});
		});

		$('.js-submit-searchAddress').on(clickEvent, function () {
			var selectAddressSmall = $('#selectSearchAddressSmall').val();
			if (selectAddressSmall) {
				if (SANGETSU.va.pathname.indexOf('curtain') !== -1) {
					var largeArea = $('#selectSearchAddressLarge option:selected').text();
					var smallArea = $('#selectSearchAddressSmall option:selected').text();
					$formAddress.attr('action', '/shop_search/list/curtain/' + selectAddressSmall + '/' + largeArea + smallArea);
					$formAddress.submit();
				} else {
					var selectCat = searchReformCategory();
					if (selectCat) {
						selectCat = searchReformCategoryQueryKana(selectCat);
						$formAddress.attr('action', '/shop_search/list/reform/area/' + selectAddressSmall + '/' + selectCat);
					} else {
						$formAddress.attr('action', '/shop_search/list/reform/area/' + selectAddressSmall);
					}
					$formAddress.submit();
				}
			} else {
				alert('市町村を選択してください');
			}
		});
	}
	function searchZipcode() {
		var inputZip = $('#inputSearchZipcode').val();
		if (inputZip) {
			inputZip = toHalfWidth(inputZip);
			inputZip = inputZip.replace(/[^0-9]/g, '');

			if (inputZip.length === 7) {
				if (SANGETSU.va.pathname.indexOf('curtain') !== -1) {
					$formZip.attr('action', '/shop_search/list/curtain/zip_code/' + inputZip.substr(0, 3));
					$formZip.submit();
				} else {
					var selectCat = searchReformCategory();
					var zipSmallAreaCode = getSmallAreaByZip(inputZip);
					if (selectCat) {
						selectCat = searchReformCategoryQueryKana(selectCat);
						// $formZip.attr('action', '/shop_search/list/reform/zip_code/' + inputZip + '/' + selectCat);
						$formZip.attr('action', '/shop_search/list/reform/area/' + zipSmallAreaCode + '/' + selectCat);
					} else {
						// $formZip.attr('action', '/shop_search/list/reform/zip_code/' + inputZip);
						$formZip.attr('action', '/shop_search/list/reform/area/' + zipSmallAreaCode);
					}
					$formZip.submit();
				}
			} else {
				alert('郵便番号を正しい形式で入力してください');
			}
		} else {
			alert('郵便番号を入力してください');
		}
	}

	// 郵便番号から住所を取得
	function getSmallAreaByZip(_zipCode) {
		var zipSmallAreaCode;
		$.ajaxSetup({ async: false });
		$.ajax({
			type: 'get',
			url: 'https://maps.googleapis.com/maps/api/geocode/json',
			crossDomain: true,
			dataType: 'json',
			data: {
				address: _zipCode,
				language: 'ja',
				sensor: false
			}
		}).done(function (resp) {
			if (resp.status === 'OK') {
				// APIのレスポンスから住所情報を取得
				var obj = resp.results[0].address_components;
				if (obj.length < 5) {
					alert('正しい郵便番号を入力してください');
					return false;
				}
				var areaData, largeAreaName, smallAreaName;
				var country = obj[4]['long_name']; // 国(政令指定都市では都道府県)
				var state = obj[3]['long_name']; // 都道府県
				var city = obj[2]['long_name']; // 市区町村
				// var town = obj[1]['long_name'];	// 町名
				if (country === '日本') {
					largeAreaName = state;
					smallAreaName = city;
				} else if (designatedCity.indexOf(state) > 0) {
					largeAreaName = country;
					smallAreaName = state + city;
				} else {
					largeAreaName = country;
					smallAreaName = city;
				}
				var jsonpathZipSmallArea = '/ajax/shop/small_area_code/' + largeAreaName + '/' + smallAreaName;
				$.getJSON(jsonpathZipSmallArea, function () {}).done(function (zipAreaData) {
					if (zipAreaData.small_area.length > 0) {
						zipSmallAreaCode = zipAreaData.small_area[0]._key;
					} else {
						zipSmallAreaCode = '9';
					}
				}).fail(function () {
					alert('施工対応エリアマスタを取得できませんでした');
				});
			} else {
				alert('住所情報が取得できませんでした');
				return false;
			}
		}).fail(function () {
			alert('Google Maps APIサービスに接続できませんでした。');
			return false;
		});
		$.ajaxSetup({ async: true });
		return zipSmallAreaCode;
	}

	// 小区分店舗数取得
	function getListCount(_$this, _cat, _listCode, _option) {
		var jsonPathListCount;
		if (_cat === 'curtain') {
			jsonPathListCount = '/ajax/shop/curtain/shop_total/' + _listCode + '/' + _option;
		} else {
			if (_option) {
				jsonPathListCount = '/ajax/shop/reform/shop_total/' + _listCode + '/' + _option;
			} else {
				jsonPathListCount = '/ajax/shop/reform/shop_total/' + _listCode;
			}
		}

		$.getJSON(jsonPathListCount, function (data) {
			if (data.shops[0]) {
				_$this.find('.vc_total').text(data.shops[0].total);
			} else {
				_$this.find('.vc_total').text('0');
				_$this.find('a').addClass('is-empty');
			}
		});
	}
	// クエリパラメータにリフォームカテゴリ付加
	function searchReformCategory() {
		var inputReformCat = $('input[name=reform_category]:checked').val();
		if (inputReformCat) {
			return '?reform_category=' + inputReformCat;
		} else {
			return '';
		}
	}
	// クエリパラメータを引き継ぐ
	function searchReformCategoryQuery() {
		if (location.search.indexOf('reform_category') !== -1) {
			return location.search;
		} else {
			return '';
		}
	}
	// クエリパラメータを日本語名に変換
	function searchReformCategoryQueryKana(_selectCat) {
		_selectCat = _selectCat.replace(/\?reform_category=/g, '');
		switch (_selectCat) {
			case 'all':
				_selectCat = 'リフォーム';break;
			case 'wall':
				_selectCat = '壁紙';break;
			case 'carpet':
				_selectCat = '床材';break;
			case 'chair':
				_selectCat = '椅子張';break;
			default:
				_selectCat = '';break;
		}
		return _selectCat;
	}
	// 半角置換
	function toHalfWidth(_strVal) {
		var halfVal = _strVal.replace(/[！-～]/g, function (tmpStr) {
			return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
		});
		return halfVal;
	}
	// 緯度経度取得
	function geocodeAddress(_address, _cnt) {
		var dfd = $.Deferred();
		var geocoder = new google.maps.Geocoder();

		geocoder.geocode({
			'address': _address
		}, function (results, status) {
			if (status === google.maps.GeocoderStatus.OK) {
				latlngs[_cnt] = results[0].geometry.location;
				dfd.resolve();
			} else {
				latlngs[_cnt] = false;
				console.log(_address);
				console.log(status);
				dfd.resolve();
			}
		});
		return dfd.promise();
	}
	// 地図とマーカーの作成
	function initMap(_latlngs) {
		var latLngBounds = new google.maps.LatLngBounds();

		// 地図の作成
		var mapLatLng = new google.maps.LatLng({ lat: _latlngs[0].lat(), lng: _latlngs[0].lng() }); // 先頭の店舗を一旦中心とする
		map = new google.maps.Map(canvas, {
			center: mapLatLng,
			zoom: 15
		});

		// マーカー毎の処理
		$.each(_latlngs, function (key, val) {
			if (val) {
				var markerLatLng = new google.maps.LatLng({ lat: val.lat(), lng: val.lng() });

				latLngBounds.extend(markerLatLng);

				$.when(marker[key] = new google.maps.Marker({
					position: markerLatLng,
					map: map
				})).done(function () {
					markerEvent(key);
				});
			}
		});
		// 複数件の場合は全てのマーカーが表示されるようにズームレベルを調整する
		if (_latlngs.length > 2) {
			map.fitBounds(latLngBounds);
		}
	}
	// マーカーにクリックイベントを追加
	function markerEvent(i) {
		// marker[i].setIcon();
		marker[i].addListener(clickEvent, function () {
			switchPickup(i - 1);
			markerInfo(i);
		});
	}
	// マーカークリック時にピックアップ店舗情報を切り替える
	function switchPickup(_num) {
		var $select = $('.shop_search-result-select');
		var item = '.shop_search-result-item';
		var selectHtml;

		selectHtml = $('.shop_search-result-list').find(item).eq(_num).prop('outerHTML');

		$select.find(item).remove();
		$select.append(selectHtml);
	}
	// マーカークリック時にツールチップを表示する
	function markerInfo(_num) {
		if (currentInfoWindow) {
			currentInfoWindow.close();
		}
		var infoWindow = new google.maps.InfoWindow({
			content: names[_num] + '<br>' + address[_num]
		});
		infoWindow.open(marker[_num].getMap(), marker[_num]);
		currentInfoWindow = infoWindow;
	}
	// お問い合わせフォームへPOST
	function sendPostForm(_name, _mail) {
		var formHtml = '<form method="post" action="' + formContactUrl + '" id="send" style="display: none;" target="_blank">' + '<input type="hidden" name="compName" value="' + _name + '">' + '<input type="hidden" name="shop_mail" value="' + _mail + '">' + '</form>';

		$('#send').remove();
		$('body').append(formHtml);
		$('#send').submit();
	}
})(window.jQuery, window.SANGETSU, window.cssua);